// Petición única de «Guardar» / «Comandar» (POST pedidos/add/accept/payment).
//
// 2026-10-08 · Antes cada pantalla (CartWidget, TPV grande, TpvPayment)
// montaba y enviaba su propia petición. El auto-guardado al salir de la mesa
// tiene que guardar EXACTAMENTE igual que el botón «Guardar», así que la
// construcción de líneas (la del CartWidget, la más completa) y el envío
// viven aquí y los usan todos.
//
//   servido=true  → «Comandar»: papel + KDS.
//   servido=false → «Guardar»:  KDS, sin papel.

import axios from "src/utils/axios";
import { loyaltyLineFields } from "src/utils/loyalty/loyaltyLineFields";

export const COMANDA_ENDPOINT = "pedidos/add/accept/payment";

const JSON_HEADERS = {
  "Content-Type": "application/json",
  "X-Requested-With": "XMLHttpRequest",
  "Access-Control-Allow-Origin": "*",
};

/** Línea del carrito (no enviada) → línea del DTO de comanda. */
export function buildComandaLine(line, { idOrder = null } = {}) {
  const complementos = Array.isArray(line?.complementos) ? line.complementos : [];
  return {
    unidades: line.quantity,
    productoId: line.id,
    nota: line.notas,
    courseLabelID: line.courseLabelID,
    precio: line.precio,
    pesoGramos: line.pesoGramos || null,
    // «Marchar al comandar» (solo con curso): el backend pone MarchadoAt.
    preMarch: !!line.preMarch,
    // Menú «Continuar más tarde» (reloj): SOLO si el camarero lo pulsó.
    isPartial: !!line._isPartial,
    // Split-by-comensal.
    idComensal: Number(line.idComensal) || 0,
    // Promociones: sin estos campos la recompensa se comandaba a 0 € sin canje.
    ...loyaltyLineFields(line),
    complementos:
      complementos.length > 0
        ? complementos.map((c) =>
            !idOrder
              ? {
                  complemento: c.id,
                  unidades: c.quantity || c.unidades,
                  notas: c.notas,
                  // Curso del complemento: nuevo `complementCourseLabelId`,
                  // legacy `courseLabelId` o `courseLabelID` de línea.
                  courseLabelID:
                    c.courseLabelID
                    ?? c.complementCourseLabelId
                    ?? c.courseLabelId
                    ?? null,
                  preMarch: !!(c.preMarch ?? line.preMarch),
                }
              : c,
          )
        : [],
  };
}

export function buildComandaLines(lines, opts) {
  return (lines || []).map((l) => buildComandaLine(l, opts));
}

export const comandaTotal = (productos) =>
  (productos || []).reduce((a, p) => a + (Number(p.precio) || 0) * (Number(p.unidades) || 0), 0);

/** DTO de `pedidos/add/accept/payment` para guardar/comandar (sin cobrar). */
export function buildComandaData({
  productos,
  idRestaurante,
  idSession = null,
  idMesa = null,
  servido,
  idEmployee = 0,
  name = "",
  idCustomer = null,
}) {
  return {
    precio: comandaTotal(productos),
    idRestaurante,
    productos,
    Bizum: false,
    Cheque: false,
    Otros: false,
    Tarjeta: false,
    Fraccionado: false,
    IdSession: idSession,
    IdMesa: idMesa,
    cuentaTarjeta: 0,
    IdCustomer: idCustomer,
    cuentaEfectivo: 0,
    pagado: false,
    cuentaBizum: 0,
    cuentaCheque: 0,
    cuentaOtros: 0,
    name,
    servido: !!servido,
    printOnServer: true,
    idEmployee: idEmployee || 0,
  };
}

/**
 * Envía la comanda. `config` extra (cabeceras de lease de otra mesa,
 * `skipLeaseHeldNotify`…) se mezcla con las cabeceras de siempre.
 */
export function postComanda(data, config = {}) {
  const { headers, ...rest } = config || {};
  return axios.post(COMANDA_ENDPOINT, JSON.stringify({ ...data }), {
    ...rest,
    headers: { ...JSON_HEADERS, ...(headers || {}) },
  });
}
